import React, { Component } from 'react';
import PathContext from "../../context/path";
import styles from './Test.module.sass';
import Socials from '../../components/Socials';
import {
	Link
} from "react-router-dom";
class Test extends Component {
	state = {
		init: false,
		stage: 0,
		true_answer: 0,
		count: 0
	}
	static contextType = PathContext;
	path = this.context;
	data = [
		{
			"question": "Как определить, болен человек ВИЧ или нет?",
			"answers": [
				"Только по результатам анализа на антитела к ВИЧ",
				"По внешним признакам и симптомам",
				"Сделать запрос в центр СПИДа"
			],
			"text": ["Наличие ВИЧ-инфекции в организме невозможно определить, исходя из внешнего вида человека или его самочувствия. Нужен анализ на наличие антител к ВИЧ. Такой анализ можно провести самостоятельно, с помощью экспресс-теста, в СПИД-центре или в поликлинике по месту жительства. Все результаты конфиденциальны и не разглашаются."],
			"img": "/img/gifs/2-pers_question.gif",
			"true_answer": 0,
			"var_answer": false
		},
		{
			"question": "Как вы думаете, кто может получить ВИЧ?",
			"answers": [
				"ВИЧ — это болезнь исключительно маргиналов",
				"ВИЧ никого не выбирает, это же вирус",
				"ВИЧ — это скорее про наркозависимых"
			],
			"text": ["ВИЧ сегодня распространился настолько, что в зоне риска находится любой человек. Независимо от увлечений и интересов, пристрастий в сексе или количества денег на карте."],
			"img": "/img/gifs/2photos.gif",
			"true_answer": 1,
			"var_answer": false
		},
		{
			"question": "В каком возрасте чаще всего узнают о своем положительном ВИЧ‑статусе?",
			"answers": [
				"18-25 лет",
				"25-29 лет",
				"30-49 лет"
			],
			"text": ["ВИЧ давно перестал быть проблемой молодёжи, которая пробует инъекционные наркотики и безудержно занимается сексом во всех его проявлениях. Сегодня ВИЧ — это проблема осознанных взрослых. 71% новых случаев ВИЧ фиксируют в возрасте 30–49 лет."],
			"img": "/img/gifs/age.gif",
			"true_answer": 2,
			"var_answer": false
		},
		{
			"question": "Какой фактор представляет собой наибольшую опасность передачи ВИЧ?",
			"answers": [
				"Гомосексуальный контакт",
				"Гетеросексуальный контакт",
				"Внутривенные инъекции"
			],
			"text": ["В настоящее время в России самым частым путем передачи ВИЧ является незащищенный гетеросексуальный контакт. 65% от общего количества инфицированных (2019 г.) заразились через секс без защиты."],
			"img": "/img/gifs/vesy.gif",
			"true_answer": 1,
			"var_answer": false
		},
		{
			"question": "Какой контакт полностью исключает риск передачи ВИЧ?",
			"answers": [
				"Оральный секс",
				"Переливание крови",
				"Использование общих предметов быта"
			],
			"text": [["Риск при оральном сексе сохраняется, если в ротовой полости есть серьезные кровоточащие повреждения, через которые вирус может попасть в организм. Ситуации, когда люди получают ВИЧ из-за медицинской ошибки, очень редки. В России фиксируют единичные подобные случаи.", " А бытовой контакт не представляет опасности. Вирус не может жить вне тела человека, а в слюне и эпителии его просто нет."], ["Ситуации, когда люди получают ВИЧ из-за медицинской ошибки, очень редки. В России фиксируют единичные подобные случаи. Риск при оральном сексе сохраняется, если в ротовой полости есть серьезные повреждения, через которые вирус может попасть в организм.", "А бытовой контакт не представляет опасности. Вирус не может жить вне тела человека, а в слюне и эпителии его просто нет."], ["Бытовой контакт не представляет опасности. Вирус не может жить вне тела человека, а в слюне и эпителии его просто нет.", "Риск при оральном сексе сохраняется, если в ротовой полости есть серьезные кровоточащие повреждения, через которое вирус может попасть в организм. Ситуации, когда люди получают ВИЧ из-за медицинской ошибки, очень редки. В России фиксируют единичные подобные случаи."]],
			"img": "/img/gifs/arms.gif",
			"true_answer": 2,
			"var_answer": true
		},
		{
			"question": "В течение какого времени после тревожного контакта нужно сделать тест на ВИЧ для более точного результата?",
			"answers": [
				"В течение недели",
				"Через месяц",
				"Через три месяца"
			],
			"text": ["Чтобы результат теста был достаточно достоверен, необходимо, чтобы прошло около трех месяцев после рискованной ситуации. В первые три месяца антитела к ВИЧ только формируются, и тест может дать неточный результат."],
			"img": "/img/gifs/timer.gif",
			"true_answer": 2,
			"var_answer": false
		},
		{
			"question": "Как обезопасить себя и своего партнера?",
			"answers": [
				"Пройти тестирование на ВИЧ и узнать свой ВИЧ-статус",
				"Пройти тестирование на ВИЧ и узнать свой ВИЧ-статус",
				"Пройти тестирование на ВИЧ и узнать свой ВИЧ-статус"
			],
			"text": ["Способов тестирования сегодня достаточно много: от лабораторий до домашних экспресс-тестов. Какой бы вы ни выбрали — это верное решение на пути здоровых сексуальных отношений и заботы о своем здоровье. Не бойтесь и не сомневайтесь. Знать ВИЧ-статус сегодня — часть заботы о вашем будущем."],
			"img": "/img/gifs/wit.gif",
			"true_answer": -1,
			"var_answer": false
		}
	];
	page = null;

	popup = null;
	componentDidMount() {
		window.scrollTo(0, 0);
		setTimeout(()=>{
			this.data.forEach((item) => {
				const img = new Image();
				img.src = `${this.path}${item.img}`;
			});
		}, 800);
		
		this.initTest();
	}

	componentWillUnmount() {
		this.setState = (state, callback) => {
			return;
		};
	}
	initTest() {
		this.setState({
			stage: 0,
			true_answer: 0,
			count: 0
		});

		this.setPage(-1);
	}
	setPage(number) {

		this.popup = null;

		this.setState({
			stage: number
		}, () => {
			if (number < 0) {
				this.page = this.setMainPage();
				this.setState({});
			} else if (number < this.data.length) {
				this.page = this.setTestPage(number);
				this.setState({});
			} else {
				this.page = this.setFinalPage();
				this.setState({});
			}
		});
	}
	setMainPage() {
		return <>
		<div className={styles.bg_inner}>
					<picture>
						<source media="(min-width: 768px)" srcSet={`${this.path}/img/test-cover-bg-desktop.png`} />

						<img src={`${this.path}/img/test-cover-bg.png`} alt="" />
					</picture>
				</div>
			<div className={styles.main_wrap}>
				
				<h1 className={styles.main_title}>
					Что вы знаете о ВИЧ-инфекции?
				</h1>

				<div className={styles.main_desc}>Проверьте уровень своих знаний</div>
				<div className={styles.main_img}>
					<img src={`${this.path}/img/gifs/question.gif`} alt="" />
				</div>
				<div className={styles.btn} onClick={this.setPage.bind(this, 0)}>СТАРТ</div>
			</div>
		</>

	}
	setTestPage(number) {
		let btn = null;
		btn = this.data[number].answers.map((item, index) => {
			return <div key={index} className={styles.btn_test} onClick={this.setAnswer.bind(this, index)}>{item}</div>
		});

		this.setState({
			true_answer: this.data[number].true_answer
		});
		return <>
		<div className={styles.bg_inner}>
					<picture>
						<source media="(min-width: 768px)" srcSet={`${this.path}/img/test-cover-bg-desktop.png`} />

						<img src={`${this.path}/img/test-cover-bg.png`} alt="" />
					</picture>
				</div>
			<div className={styles.header}>
				
				<div className={styles.title}>{this.data[number].question}</div>
				<div className={styles.counter}>{`${number + 1} | ${this.data.length}`}</div>
			</div>
			<div className={styles.img}>
				<img key={number} src={`${this.path}${this.data[this.state.stage].img}`} alt="" />
			</div>
			<div className={styles.btns}>
				{btn}
			</div>
		</>

	}
	setFinalPage() {
		let title = 'Есть повод заполнить пробелы!';
		let text = 'Теперь вы знаете о вирусе больше и понимаете, почему ваш ВИЧ-статус важен. А ошибки — это всего лишь повод их исправить!';
		if (this.state.count === this.data.length) {
			title = 'Отличный результат!';
			text = 'Теперь вы знаете о вирусе больше и понимаете, почему ваш ВИЧ-статус важен.';
		}
		return <>
				<div className={styles.bg_inner}>
					<picture>
						<source media="(min-width: 768px)" srcSet={`${this.path}/img/test-cover-bg-desktop.png`} />

						<img src={`${this.path}/img/test-cover-bg.png`} alt="" />
					</picture>
				</div>
			<div className={styles.final_header}>
				
				<div className={styles.final_counter}>{`${this.state.count} | ${this.data.length}`}</div>
				<div className={styles.final_title}>{title}</div>
			</div>
			<div className={styles.final_text}>{text}</div>
			<div className={styles.socials}>
				<Socials />
			</div>
			<div className={styles.final_btns}>
				<div className={`${styles.btn} ${styles.btn_trans}`} onClick={this.initTest.bind(this)}>пройти еще раз</div>
				<Link to='/' className={styles.btn}>перейти в проект</Link>
			</div>
		</>

	}
	setAnswer(number) {
		let bool = true;
		if (this.state.true_answer === number || this.state.true_answer < 0) {
			bool = true;
			this.setState({
				count: this.state.count + 1
			});
		} else {
			bool = false;
		}
		this.showPopup(bool, number);

		this.setState({});
	}
	showPopup(bool, number) {
		let style = `${styles.popup}`;
		let title = 'Верно!';
		let next = 'Узнать результат';

		if (this.state.stage < this.data.length - 1) {
			next = 'Дальше';
		}
		if (bool === false) {
			style = `${styles.popup} ${styles.popup_false}`;
			title = 'Неверно!';
		}
		let text = this.data[this.state.stage].text[0];
		if (this.data[this.state.stage].var_answer === true) {
			text = this.data[this.state.stage].text[number].map((item, index) => {
				return <p key={index}>{item}</p>
			});
		}
		this.popup = <div className={style}>
			<div className={styles.popup_overlay}></div>
			<div className={styles.popup_body}>
				<div className={styles.popup_title}>{title}</div>
				<div className={styles.popup_text}>{text}</div>
				<div className={styles.popup_btn} onClick={this.setPage.bind(this, this.state.stage + 1)}>{next}</div>
			</div>
		</div>
	}
	render() {


		return <div className={`${styles.wrap} ${styles[`wrap_${this.state.stage}`]}`}>
			<div className={styles.bg}>
				<picture>
					<source media="(min-width: 768px)" srcSet={`${this.path}/img/test-bg-desktop.png`} />

					<img src={`${this.path}/img/test-bg.png`} alt="" />
				</picture>
			</div>
			{this.popup}
			<div className={styles.page} >
				{this.page}
			</div>
		</div>;
	}
}

export default Test;
